import React, { Fragment } from "react";
import { Row, Col } from "antd";
import UserAvatar from "../../../blocks/UserAvatar";
import Logo from "../../../Logo/Logo";
import MobileLogo from "../../../Logo/MobileLogo";
import { useHistory } from "react-router-dom";
import "./AdminToolbar.css";
import { isDesktop } from "react-device-detect";

const AdminToolbar = () => {
  const history = useHistory();

  return (
    <Fragment>
      <Row style={{ width: "100%" }} className="menu" justify="space-between" align="middle">
        <Col>
          <div
            className="admin-menu-logo"
            onClick={() => history.push("/admin/dashboard")}
          >
            {isDesktop ? <Logo /> : <MobileLogo />}
          </div>
        </Col>
        <Col className="admin-menu-dropdown">
          <UserAvatar />
        </Col>
      </Row>
    </Fragment>
  );
};
export default AdminToolbar;
